<template>
  <b-container class="main-area">
    <b-row>
      <b-col md="12" sm="12">
        <h1 class="centered">Запись на курсы</h1>
        <br>
        <p>
          Для записи на курсы, заполните анкету, соответствующую вашему уровню подготовки
        </p>
        <hr class="my-4">
        <small class="text-muted">Поля, отмеченные звёздочкой, обязательны к заполнению</small>
        <b-card no-body>
          <b-tabs card class="nav-fill">
            <b-tab title="Начальный уровень">
              <EntryLvlForm @submitSuccess="successSubmit"> </EntryLvlForm>
            </b-tab>
            <b-tab title="Повышение квалификации">
              <AdvancedLvlForm @submitSuccess="successSubmit"> </AdvancedLvlForm>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
    <b-modal ref="modal">
        В ближайшее время наши менеджеры с вами свяжутся
        <span slot="modal-title">Анкета успешно отправлена!</span>
        <template slot="modal-footer">
          <button type="button" class="btn btn-success" @click="hideModal">Закрыть</button>
        </template>
    </b-modal>
  </b-container>
</template>

<script>
import EntryLvlForm from '../forms/EntryLevelQuestionnaire'
import AdvancedLvlForm from '../forms/AdvancedLevelQuestionnaire'

export default {
  methods: {
    successSubmit () {
      if (this.$getYaCounter) {
        this.$getYaCounter().reachGoal('sendingForm')
      }
      this.$refs.modal.show()
    },
    hideModal () {
      this.$refs.modal.hide()
    }
  },
  components: {
    EntryLvlForm,
    AdvancedLvlForm
  }
}
</script>



// WEBPACK FOOTER //
// OnlineEnrollment.vue?72dcf925